var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPkPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_356_1247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_356_1247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4H37V28H13V4Z",
    fill: "#2F8D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4H13V28H5V4Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4296 19.3062C27.4296 19.3062 22.9638 20.4705 19.4191 18.0956C15.8744 15.7206 17.6563 10.2477 17.6563 10.2477C15.8073 10.5168 12.9037 17.2626 17.5841 20.6461C22.2645 24.0296 26.7483 20.7772 27.4296 19.3062ZM22.4739 12.8665L20.1024 14.0261L22.6042 14.4717L22.9419 16.9172L24.359 14.8344L27.1475 15.0224L24.9634 13.3935L26.1261 11.2172L23.9518 12.213L22.3365 10.6944L22.4739 12.8665Z",
    fill: "#F1F9FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkPakistan);
export default __webpack_public_path__ + "static/media/PK - Pakistan.cad56d1d3b7cdcb3229210589e080595.svg";
export { ForwardRef as ReactComponent };